import values from 'lodash/values';
import PropTypes from 'prop-types';

export const Stage = {
  Groups: 'groups',
  Bracket: 'bracket'
};
export const stages = values(Stage);

export const Bracket = {
  Forward: 'forward',
  Final: 'final',
  Reverse: 'reverse'
};
export const brackets = values(Bracket);

export const Round = {
  Roundof32: 'roundof32',
  Roundof16: 'roundof16',
  Quarter: 'quarter',
  Semi: 'semi',
  Third: 'third',
  Final: 'final'
};
export const rounds = values(Round);

export const TeamStanding = {
  Winner: 'winner',
  Loser: 'loser'
};
export const teamStandings = values(TeamStanding);

export const MatchProps = {
  MatchId: 'mid',

  TeamHome: 'teamHome',
  TeamAway: 'teamAway',

  FromHome: 'fromHome',
  FromAway: 'fromAway',

  ScoreHome: 'scoreHome',
  ScoreAway: 'scoreAway',

  Winner: 'winner',

  Datetime: 'datetime',

  Stage: 'stage',
  Group: 'group',
  Round: 'round',

  Stadium: 'stadium',
  Venue: 'venue'
};

export const groups = 'abcdefghijkl'.split('');

const MatchIdType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const fromPropType = PropTypes.oneOfType([
  PropTypes.shape({
    pos: PropTypes.number,
    group: PropTypes.string
  }),
  PropTypes.shape({
    type: PropTypes.oneOf(teamStandings),
    [MatchProps.MatchId]: MatchIdType
  })
]);

export const MatchPropTypes = {
  [MatchProps.MatchId]: MatchIdType,

  [MatchProps.TeamHome]: PropTypes.string,
  [MatchProps.TeamAway]: PropTypes.string,

  [MatchProps.ScoreHome]: PropTypes.number,
  [MatchProps.ScoreAway]: PropTypes.number,

  [MatchProps.Winner]: PropTypes.oneOf(['home', 'away']),

  [MatchProps.FromHome]: fromPropType,
  [MatchProps.FromAway]: fromPropType,

  [MatchProps.Datetime]: PropTypes.string,

  [MatchProps.Stage]: PropTypes.oneOf(stages),
  [MatchProps.Group]: PropTypes.oneOf(groups),
  [MatchProps.Round]: PropTypes.oneOf(rounds),

  [MatchProps.Stadium]: PropTypes.string,
  [MatchProps.Venue]: PropTypes.string
};
